import { attr, fk } from 'redux-orm';
import Model from '../base-model';
import forumAttachmentsReducers from './forum-attachments.reducer';
import { forumAttachmentsActions } from './forum-attachments.action';


/**
 * ForumAttachment
 * @typedef {Object} ForumAttachment
 * @property {string} id
 * @property {string} title
 * @property {string} url
 * @property {number} uploadingProgress
 * @property {number} fileType
 * @property {number} title
 * @property {number} status
 */

export class ForumAttachment extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
        case forumAttachmentsActions.createAttachment:
            forumAttachmentsReducers.createAttachment(session, action.id, action.title, action.url, action.fileType, action.status, action.postId, action.image);
            break;
        case forumAttachmentsActions.changeAttachmentStatus:
            forumAttachmentsReducers.changeAttachmentStatus(session, action.id, action.status);
            break;
        case forumAttachmentsActions.changeAttachmentProgress:
            forumAttachmentsReducers.changeAttachmentProgress(session, action.id, action.progress);
            break;
        case forumAttachmentsActions.attachAttachmentToPost:
            forumAttachmentsReducers.attachAttachmentToPost(session, action.id, action.postId);            
            break;
        case forumAttachmentsActions.setAttachmentCorrectValue:
            forumAttachmentsReducers.setAttachmentCorrectValue(session, action.id, action.newId, action.url, action.title, action.image)
            break;
        case forumAttachmentsActions.deleteAttachment:
            forumAttachmentsReducers.deleteAttachment(session, action.id);
            break;
        case forumAttachmentsActions.deleteAllDraftAttachment:
            forumAttachmentsReducers.deleteAllDraftAttachment(session);
            break;
        case forumAttachmentsActions.deleteAllPostAttachment:
            forumAttachmentsReducers.deleteAllPostAttachment(session, action.postId);
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `Attachment: ${this.title}`
    }
}

ForumAttachment.modelName = 'ForumAttachment';

ForumAttachment.fields = {
    id: attr(),
    title: attr(),
    url: attr(),
    uploadingProgress: attr(),
    fileType: attr(),
    post: fk('Post', 'attachments'),
    image: attr(),
    status: attr(),
}